define('main_link',[
	'backbone',
	'even'
], function (Backbone, Even) {

	/*
	 * View for the main-navigation.
	 * Handles navigation-highlighting.
	**/
	return Backbone.View.extend({

		// tmpl : $('#main_menu-tmpl').html(),
		// view : Tmpl['main_link.hbs']
		view : false

		, events : {
			'click a' : 'toggleCurrentClass'
		}

		/*
		 * Rendering and subscribing to the event emitted
		 * after each page-change by the wp-collection.
		**/
		, initialize : function initialize(opts) {
            this.opts = opts || {};
			this.view = this.opts.view;
			// events.on('UI.handleCurrentClass', this.handleCurrentClass, this);
			// console.log('... Render Part Link');
			// console.log('... options: ')
			// console.log(options)
			// this.data = options.data;
			this.render();
		}

		/*
		 * The actual rendering.
		**/
		, render : function render() {
			// return this.$el.html(Mustache.render(this.tmpl, {
			// 	'nav-items' : BB.main_nav
			// }));
			// return this.$el.html(Mustache.render(this.tmpl, BB.main_navigation));
			// console.log('this.data: ');
			// console.log(this.data);
			return this.$el.html(this.view(this.opts.data));
		}

		/*
		 * Toggling the navigation-highlighting.
		**/
		, toggleCurrentClass : function toggleCurrentClass(evnt) {
			// console.log('Click');
			// console.log('navigation-view toggleCurrentClass: ' + $(evnt.currentTarget).text() );
			// console.dir('' + evnt.currentTarget);

			// //-- 
			// if($(evnt.currentTarget).hasClass('navbar-brand')){
			// 	$(evnt.currentTarget.parentNode.parentNode).find('li a[href="'+BB.base_url+'/'+'"]').parent().addClass('current_page_item').siblings().removeClass('current_page_item');
			// }
			// else {
			// 	// $(evnt.currentTarget.parentNode).addClass('current_page_item').siblings().removeClass('current_page_item');
			// 	$(evnt.currentTarget.parentNode).addClass('current_page_item').siblings().removeClass('current_page_item');
			// }
			// $(evnt.currentTarget.parentNode).addClass('current_page_item').siblings('.current_page_item').removeClass('current_page_item');
		}

		/*
		 * Removing the navigation-highlighting, if the active page
		 * is not a static page.
		**/
		, handleCurrentClass : function handleCurrentClass(type) {
			// console.log('Menú initialize handleCurrentClass: ' + type );
			// if ( type === 'page' || type === 'page_smiles' ){ return; }
			// if ( type != 'single' ){ return; }
			// this.$('li').removeClass('current_page_item');
		}

	});

});
